import { searchVolopsSegments } from 'modules/search/routing/search.route-segments';
import { searchVolopsRouteReference } from 'modules/search/routing/search.routes';
import { SearchVolopFiltersByName } from 'modules/search/types/FiltersByName/SearchVolopFiltersByName';
import { SortType } from 'store/mainSearch/MainStoreMainSearchState';

import { searchGetQueryParamsFromFiltersByName } from './searchGetQueryParamsFromFiltersByName';

type Args = {
  lang: UserLocale;
  q?: string;
  radius?: 'state' | 'country' | 'auto' | string | null;
  filtersByName?: Omit<SearchVolopFiltersByName, 'type'>;
  sort?: SortType;
  pageIndex?: number;
};

export function searchGetVolopsRoutePath({
  lang,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const segment = searchVolopsSegments[lang];

  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchVolopsRouteReference.with({ lang, segment, ...queryParams });
}
